import * as dto from 'client/dto';
import { InsightsState } from 'app-redux/InsightsState';
import { nameof } from 'utils/typeHelpers';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type MetadataState = {
  metadata: dto.ApplicationMetadataModel;
  isLoading: boolean;
  hasError: boolean;
};

export const InitialMetadataState: MetadataState = {
  metadata: null,
  isLoading: false,
  hasError: false,
};

const metadataSlice = createSlice({
  name: nameof<InsightsState>('metadata'),
  initialState: InitialMetadataState,
  reducers: {
    loadMetadataStart: state => {
      state.isLoading = true;
    },
    loadMetadataSuccess: (state, action: PayloadAction<dto.ApplicationMetadataModel>) => {
      state.metadata = action.payload;
      state.isLoading = false;
      state.hasError = false;
    },
    loadMetadataError: state => {
      state.isLoading = false;
      state.hasError = true;
    },
  },
});

const { actions, reducer } = metadataSlice;
export const { loadMetadataStart, loadMetadataSuccess, loadMetadataError } = actions;

export default reducer;
